import { DisplayItem } from "../types";
//import { getRewardsById } from "./helper";
import { offersApi } from "redux/apis";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { Config, DipButton, PurchaseOfferSingleItem } from "interfaces";
import useRewardsById from "hooks/useRewardsById";
//import { useEffect } from "react";

export const useDIPRewardsV2 = (item: DipButton | undefined): DisplayItem => {
	const { authToken } = useWebStoreContext();
	const { data: loyaltyOffers } = offersApi.endpoints.getOffers.useQueryState({
		offerType: "loyalty",
		isAuthenticated: !!authToken?.value
	});
	const { data: purchaseOffers } = offersApi.endpoints.getOffers.useQueryState({
		offerType: "singleItem",
		isAuthenticated: !!authToken?.value
	});

	// Pre-calculate all possible rewardIds
	const rewardId = item?.rewardId as string | undefined;

	const loyalty = loyaltyOffers?.offers?.find(
		(c: Config) => c.id === item?.loyaltyOfferId
	);
	const loyaltyRewardId = loyalty?.rewardId;

	const offer = purchaseOffers?.offers?.find(
		(offer: Config) => offer.id === item?.offerId
	) as PurchaseOfferSingleItem | undefined;
	const offerRewardId = offer?.rewardId;

	// Call all hooks at the top level
	const rewardById = useRewardsById(rewardId || "");
	const loyaltyRewardById = useRewardsById(loyaltyRewardId || "");
	const offerRewardById = useRewardsById(offerRewardId || "");

	let displayItem: DisplayItem = {
		buyType: "usd",
		price: 0,
		rewards: []
	};

	switch (item?.actionType) {
		case "grantReward":
		case "grantLoyaltyReward":
			displayItem = {
				...displayItem,
				rewards: rewardById,
				buttonLabel: "CLAIM"
			};
			break;
		case "loyaltyPurchase":
			if (loyalty) {
				displayItem = {
					...displayItem,
					price: loyalty.loyaltyPointPrice,
					buyType: "loyalty_points",
					rewards: loyaltyRewardById
				};
			}
			break;
		case "offerPurchase":
			if (offer) {
				displayItem = {
					...displayItem,
					price: offer.price,
					buyType: "usd",
					loyaltyPointCrossout: offer.loyaltyPointCrossout,
					loyaltyPointReward: offer.loyaltyPointReward,
					rewards: offerRewardById,
					rewardMultiplier: offer.rewardMultiplier,
					badgeText: offer.badgeText,
					badgeImageUrl: offer.badgeImageUrl
				};
			}
			break;
		default:
			console.log(`Reward - ActionType not handled: ${item?.actionType}`);
	}

	return displayItem;
};
